import React, { FunctionComponent } from 'react';

import { AppBar } from './components/AppBar';
import { Contact } from './components/Contact';
import { CurrentEventMilestones } from './components/CurrentEventMilestones';
import { Hero } from './components/Hero';
import { Informations } from './components/Informations';
import { Place } from './components/Place';

export const Home: FunctionComponent = () => {
  return (
    <>
      <AppBar />
      <Hero />
      <CurrentEventMilestones />
      <Place />
      <Informations />
      <Contact />
    </>
  );
};
